var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
    Author:
    Date: 2018/11/02
    Usage: Render Layout Sidebar List
    Parent: ./twmsMaterial.jsx, handleWidthChange
    Childern: none, none
*/
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSidebarlistOpen, setActiveTaskId } from 'reducers/Layout/action';
import { getApplicationCodesRedux, getUserMenusRedux, } from 'reducers/Login/selector';
import { getActiveTaskId, getSidebarOpen, getSidebarItems, } from 'reducers/Layout/selector';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';
import { Accordion, AccordionSummary, AccordionDetails, } from '@material-ui/core';
import { setPageTypeRedux, setResetKeyRedux } from 'reducers/sharedata/action';
import { PageTypeEnum } from 'reducers/sharedata/types';
import Breadcrumb from './Breadcrumb';
import PopDialog, { popObjToggle } from 'component/LHH/PopDialog/PopDialog';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var SidebarListStyle = require('./SidebarListStyle.module.css');
var StyledExpansionPanelSummary = withStyles({
    root: {
        padding: '6px 12px',
        margin: 0,
        color: 'white',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
        minHeight: 'initial',
        fontSize: '0.85em',
        '&:hover': { color: '#0086da' },
        '&$expanded': { minHeight: 'initial' },
    },
    content: {
        margin: '0px',
        '&$expanded': { margin: '0px' },
    },
    expanded: { minHeight: 'initial' },
})(AccordionSummary);
var StyledExpansionPanelDetails = withStyles({
    root: {
        display: 'block',
        padding: '0px',
        backgroundColor: '#4a596f',
        fontSize: '0.85em',
    },
})(AccordionDetails);
var StyledListItem = withStyles({
    root: {
        color: 'white',
        textDecoration: 'none',
        padding: '8px 12px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
        fontSize: '0.85em',
        '&:hover': { color: '#0086da' },
        '&$selected': { backgroundColor: 'rgb(0, 134, 218)' },
    },
    selected: {
        backgroundColor: 'rgb(0, 134, 218)',
        '&:hover': {
            color: 'white',
            fontWeight: 'bold',
            backgroundColor: 'rgb(0, 134, 218) !important',
        },
    },
})(ListItem);
var StyledIconButton = withStyles({
    root: {
        backgroundColor: 'rgb(255, 186, 2);',
        borderRadius: '0%',
        padding: '8px 12px',
        color: 'white',
        '&:hover': {
            backgroundColor: 'rgb(255, 186, 2, 0.8);',
        },
    },
})(IconButton);
export var StyledExpansionPanel = withStyles({
    root: {
        backgroundColor: 'transparent',
        margin: '0',
        color: 'white',
        position: 'initial',
        '&$expanded': { margin: '0px' },
    },
    expanded: {
        backgroundColor: '#323d4e',
        margin: '0px',
    },
})(Accordion);
export var dToolTipProps = function (taskId) {
    return ({
        title: taskId,
        'aria-label': taskId,
        arrow: true,
        placement: 'right',
    });
};
var SidebarListItemPrint = function (props) {
    var sidebarItems = useSelector(getSidebarItems);
    var activeTaskId = useSelector(getActiveTaskId);
    var handleItemClick = props.handleItemClick;
    return (React.createElement(React.Fragment, null, sidebarItems.map(function (obj) {
        // eslint-disable-next-line no-nested-ternary
        return obj.children != null ? (React.createElement(StyledExpansionPanel, { key: obj.taskId },
            React.createElement(Tooltip, __assign({}, dToolTipProps(obj.taskId)),
                React.createElement(StyledExpansionPanelSummary, { IconButtonProps: { size: 'small' }, expandIcon: React.createElement(ExpandMoreIcon, { style: { color: 'white' } }), onClick: handleItemClick(obj.taskId, obj.taskName) }, obj.taskName)),
            React.createElement(StyledExpansionPanelDetails, null, obj.children.map(function (propss) {
                return propss.isExternalUrl === 'N' ? (React.createElement(NavLink, { to: propss.menuUrl || '#', className: SidebarListStyle.item, activeClassName: "active", key: propss.taskId, onClick: handleItemClick(propss.taskId, propss.taskName) },
                    React.createElement(Tooltip, __assign({}, dToolTipProps(propss.taskId)),
                        React.createElement(StyledListItem, { button: true, selected: activeTaskId === propss.taskId }, propss.taskName)))) : (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: obj.menuUrl, key: obj.taskId, className: SidebarListStyle.item },
                    React.createElement(Tooltip, __assign({}, dToolTipProps(propss.taskId)),
                        React.createElement(ListItem, { button: true }, propss.taskName))));
            })))) : obj.isExternalUrl === 'N' ? (React.createElement(NavLink, { to: obj.menuUrl || '#', activeClassName: "active", key: obj.taskId, className: SidebarListStyle.item },
            React.createElement(Tooltip, { title: obj.taskId, "aria-label": obj.taskId, arrow: true, placement: "right" },
                React.createElement(StyledListItem, { button: true, selected: activeTaskId === obj.taskId, onClick: handleItemClick(obj.taskId, obj.taskName) }, obj.taskName)))) : (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: obj.menuUrl, key: obj.taskId, className: SidebarListStyle.item },
            React.createElement(Tooltip, { title: obj.taskId, "aria-label": obj.taskId, arrow: true, placement: "right" },
                React.createElement(StyledListItem, { button: true, selected: activeTaskId === obj.taskId, onClick: handleItemClick(obj.taskId, obj.taskName) }, obj.taskName))));
    })));
};
var SidebarListDisplay = function (props) {
    var _a = useState({
        show: false,
        handleExit: function () { return popObjToggle(setPopDlgObj); },
    }), popDlgObj = _a[0], setPopDlgObj = _a[1];
    var dispatch = useDispatch();
    var sidebarOpen = useSelector(getSidebarOpen);
    var handleItemClick = props.handleItemClick, urlPath = props.urlPath, breadCrumbApplicationCode = props.breadCrumbApplicationCode, breadCrumbTaskItem = props.breadCrumbTaskItem;
    var _b = React.useState({
        height: 'calc(100vh - 79px)',
    }), sidebarStyle = _b[0], setSidebarStyle = _b[1];
    useEffect(function () {
        var handleResize = function () {
            var header = document.getElementsByClassName('header')[0];
            var menu = document.getElementsByClassName('MenuShow')[0];
            if (header && menu) {
                var headerHeight = header.clientHeight;
                var menuHeight = menu.clientHeight;
                var height = "calc(100vh - " + (headerHeight + menuHeight) + "px)";
                if (height !== sidebarStyle.height) {
                    setSidebarStyle({ height: height });
                }
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
    }, []);
    return (React.createElement("div", null,
        React.createElement(PopDialog, __assign({}, popDlgObj)),
        React.createElement(Hidden, { smDown: true },
            React.createElement(Slide, { direction: "right", in: sidebarOpen, mountOnEnter: true, unmountOnExit: true },
                React.createElement("div", { className: SidebarListStyle.sidebarlist, style: sidebarStyle },
                    React.createElement(SidebarListItemPrint, { handleItemClick: handleItemClick }))),
            React.createElement("div", { className: SidebarListStyle.listitem + " " + SidebarListStyle.breadcrumb, style: sidebarOpen ? { width: 'calc(100% - 200px)' } : { width: '100%' } },
                React.createElement(StyledIconButton, { onClick: function () { return dispatch(setSidebarlistOpen(sidebarOpen)); } }, sidebarOpen ? (React.createElement(KeyboardArrowLeftIcon, null)) : (React.createElement(KeyboardArrowRightIcon, null))),
                React.createElement(Breadcrumb, { urlPath: urlPath, applicationCode: breadCrumbApplicationCode, taskItem: breadCrumbTaskItem })),
            sidebarOpen && (React.createElement("img", { onClick: function () {
                    setPopDlgObj(function (prev) { return (__assign(__assign({}, prev), { show: true, title: 'EPA', children: (React.createElement("img", { alt: "EPA", src: "/image/EPA.jpg", style: { width: '100%' } })) })); });
                }, alt: "EPA", src: "/image/EPA3.jpg", style: {
                    position: 'fixed',
                    left: 5,
                    bottom: 7,
                    height: '10%',
                    width: '190px',
                    borderRadius: 5,
                    cursor: 'pointer',
                } })))));
};
var SidebarList = function (props) {
    var dispatch = useDispatch();
    var activeTaskId = useSelector(getActiveTaskId);
    var userMenu = useSelector(getUserMenusRedux);
    var applicationCodes = useSelector(getApplicationCodesRedux);
    var urlPath = props.urlPath;
    var breadCrumbTaskIdTmp = userMenu.filter(function (el) { return el.taskId === activeTaskId; });
    var breadCrumbApplicationCodeTmp = [];
    if (breadCrumbTaskIdTmp.length > 0) {
        breadCrumbApplicationCodeTmp = applicationCodes.filter(function (e) { return e.menuId === breadCrumbTaskIdTmp[0].parentId; });
    }
    var breadCrumbApplicationCode = '';
    var breadCrumbTaskItem = {
        taskId: '',
        parentId: '',
        taskName: '',
    };
    if (breadCrumbApplicationCodeTmp.length > 0) {
        breadCrumbApplicationCode = breadCrumbApplicationCodeTmp[0].taskName;
    }
    if (breadCrumbTaskIdTmp.length > 0) {
        breadCrumbTaskItem = breadCrumbTaskIdTmp[0];
    }
    /*
          Usage: Change sidebarOpen
          Param: none
          As Callback: <SidebarListDisplay/>
      */
    var handleItemClick = function (taskId) { return function () {
        var pathnameArray = urlPath.split('/');
        var pathnameTaskId = pathnameArray.pop();
        if (process.env.REACT_APP_DEBUG_MODE === 'ON') {
            // eslint-disable-next-line no-console
            console.log('SidebarList handleItemClick pathnameArray', pathnameArray);
            // eslint-disable-next-line no-console
            console.log('SidebarList handleItemClick pathnameTaskId', pathnameTaskId);
            // eslint-disable-next-line no-console
            console.log('SidebarList handleItemClick activeTaskId', activeTaskId);
        }
        // reset to defalut when click menu
        dispatch(setPageTypeRedux(PageTypeEnum.home));
        dispatch(setResetKeyRedux(Math.random()));
        if (pathnameTaskId.toUpperCase() !== activeTaskId.toUpperCase()) {
            // LogWrite(jwtData, userId, taskId, "使用" + taskName)
            window.sessionStorage.setItem('userUsingTask', taskId);
            dispatch(setActiveTaskId(taskId));
        }
    }; };
    useEffect(function () {
        var pathnameArray = urlPath.split('/');
        var pathnameTaskId = pathnameArray.pop().toUpperCase(); // pathnameArray 會少最後一個
        if (pathnameTaskId !== activeTaskId.toUpperCase()) {
            window.sessionStorage.setItem('userUsingTask', pathnameTaskId);
            dispatch(setActiveTaskId(pathnameTaskId));
        }
    }, []);
    return (React.createElement(SidebarListDisplay
    // handleItemClick={handleItemClick}
    , { 
        // handleItemClick={handleItemClick}
        handleItemClick: handleItemClick, urlPath: urlPath, breadCrumbApplicationCode: breadCrumbApplicationCode, breadCrumbTaskItem: breadCrumbTaskItem }));
};
export default SidebarList;
